import { Page } from "components/common";
import { useState } from "react";
import { Trans } from "react-i18next";
import Holidays from "./Holidays";
import Accrued from "./Accrued";
import BackButton from "components/refactoring/BackButton"

const { Nav, TabContent, TabPane } = require("reactstrap");

export default function TimeOff(props) {
  const [activeTab, setActiveTab] = useState('1');

  return (
    <Page title="Time Off" className="inv-tabs nw-list">
      <BackButton />
      <Nav tabs className="nw-tabs2 inv-tabs mb-3">
        <div onClick={() => setActiveTab('1')} className={`btn ${activeTab == '1' ? `active-tab` : ''}`}>
          <Trans>Ongoing Requests</Trans>
        </div>
        <div onClick={() => setActiveTab('2')} className={`btn ${activeTab == '2' ? `active-tab` : ''}`}>
          <Trans>Accrued</Trans>
        </div>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <Holidays {...props} />
        </TabPane>
        <TabPane tabId="2">
          {activeTab == '2' &&
            <Accrued {...props} />
          }
        </TabPane>
      </TabContent>
    </Page>
  )
}

